export enum StatusPillColorsEnum {
    GREEN,
    RED,
    YELLOW,
    DARK_GRAY,
    LIGHT_GRAY,
    ORANGE,
    PINK,
    BLUE,
    PURPLE,
}
